import { API_URL } from 'config';

const TOKEN_KEY = 'agrinexus_admin_token';
const EMAIL_KEY = 'agrinexus_admin_email';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getEmail() {
  return localStorage.getItem(EMAIL_KEY);
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export async function login(email, password) {
  const res = await fetch(`${API_URL}/identity/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Invalid email or password');
  }
  if (data.mfaRequired) {
    // This admin UI doesn't implement the MFA-verify step yet - only
    // relevant if MFA is later enabled on an admin account.
    throw new Error('MFA is enabled on this account; MFA verification is not yet supported in this admin UI.');
  }
  localStorage.setItem(TOKEN_KEY, data.accessToken);
  localStorage.setItem(EMAIL_KEY, email);
}

export async function register({ organizationName, countryCode, email, password, farmFocus }) {
  const res = await fetch(`${API_URL}/identity/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      organizationName,
      organizationType: 'FARMER',
      countryCode,
      email,
      password,
      farmFocus
    })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Could not create your account');
  }
  localStorage.setItem(TOKEN_KEY, data.accessToken);
  localStorage.setItem(EMAIL_KEY, email);
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
}
